import ProductsAPI from 'api/products';
import { task, collated } from './helpers';

export class Products {
	@task
	@collated
	fetchByProductGroup({ group_code }) {
		return ProductsAPI.fetchByProductGroup(group_code);
	}

	@task
	fetchPromotions() {
		return ProductsAPI.fetchPromotions();
	}

	@task
	@collated
	fetchOfferings({ categoryId, promotionId }) {
		return ProductsAPI.fetchOfferings(categoryId, promotionId);
	}

	@task
	fetchDownloadPromotion(promotionId, isPdf, categoryId) {
		return ProductsAPI.fetchDownloadPromotion(promotionId, isPdf, categoryId);
	}
}

export default new Products();



// WEBPACK FOOTER //
// ./src/state/Products.js